/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ListDialog extends NoboxEntityDialog<ListRow, any> {
        protected getFormKey() { return ListForm.formKey; }
        protected getIdProperty() { return ListRow.idProperty; }
        protected getLocalTextPrefix() { return ListRow.localTextPrefix; }
        protected getNameProperty() { return ListRow.nameProperty; }
        protected getService() { return ListService.baseUrl; }
        protected getDeletePermission() { return ListRow.deletePermission; }
        protected getInsertPermission() { return ListRow.insertPermission; }
        protected getUpdatePermission() { return ListRow.updatePermission; }

        private leadsGrid: ListLeadGrid;

        protected form = new ListForm(this.idPrefix);


        constructor(container?: JQuery) {
            super(container);
            this.leadsGrid = new ListLeadGrid(this.byId('LeadsGrid'));
            this.leadsGrid.openDialogsAsPanel = true;
            if ($(document).width() < 576) {
                this.form.In.toggle(false);
                this.form.Up.toggle(false);
            }
        }

        //validateEntity(row, id) {
        //    var sameContact = Q.tryFirst(this.leadsGrid.getItems(), x => x.ListId === row.ListId);
        //    if (sameContact && this.id(sameContact) !== id) {
        //        Q.alert('This contact is already in this list!');
        //        return false;
        //    }
        //    return true;
        //}

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();
            var $this = this;
            if (!Authorization.hasPermission("List:Delete")) {
                buttons[2].disabled = true;
            }
            buttons.push({
                title: "Add Contacts",
                icon:"fa-users text-blue",
                cssClass: "add-button-contact",
                visible: false,
                separator:true,
                onClick: () => {
                    var dlg = new AddContactDialog({ ID: `${this.get_entityId()}`, leadsGrid: this.leadsGrid });
                    dlg.dialogOpen();
                }
            });
            buttons.push({
                title: "Remove All Contacts",
                icon:"fa-users text-red",
                cssClass: "remove-all-contact",
                visible: false,
                separator:true,
                onClick: () => {
                    Q.confirm("Do you want to remove all contacts from this List? You can assign List again in the future.", () => {
                        Q.serviceCall({
                            blockUI: false,
                            url: "/Services/Nobox/List/DeleteAllContact",
                            request: {
                                EntityId: this.get_entityId()
                            },
                            onSuccess: (res) => {
                                Q.notifySuccess(`Success remove contacts`);
                                this.leadsGrid.refresh();
                            },
                            onError: (error) => {
                                Q.notifyError(error);
                            }
                        })
                    });
                }
            });
            return buttons;
        }

        loadEntity(entity: ListRow) {
            super.loadEntity(entity);

            //Serenity.TabsExtensions.setDisabled(this.tabs, 'Leads', this.isNewOrDeleted());
            if (this.isNewOrDeleted()) {
                this.byId('LeadsGrid').hide();
                this.form.GridContainer.element.closest('.category').toggle(false);
            }
            if (this.isEditMode()) {
                this.element.find(".add-button-contact").toggle(true);
                this.element.find(".remove-all-contact").toggle(true);
            }
            Q.reloadLookup("Nobox.ListLookup");
            this.leadsGrid.listId = `${entity.Id}`;
        }

        getTemplate() {
            return `<div class="s-DialogContent">
                        <div id="~_Toolbar" class="s-DialogToolbar">
                        </div>
                        <div class="s-Form">
                            <form id="~_Form" action="">
                                <div class="fieldset">
                                    <div id="~_PropertyGrid"></div>
                                    <div class="clear"></div>
                                </div>
                            </form>
                            <div id="~_LeadsGrid" class="mt-3"></div>
                        </div>
                    </div>`;
        }
    }
}